// GLOBAL VARIABLE SETUP
// =================================================================================================
// COMPONENTS
import React from 'react';

// HELP FUNCTIONS
import '../../utils/canvas-to-blob';
import '../../utils/kawo-tooltip';

// COMPONENT SPECIFIC IMAGES
import logo from '../../icon.png';
import logo2x from '../../icon@2x.png';

import '../../styles/upload.css';


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class Upload extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		this.state = {
			inDropBounds: false
		};

		this.dragCounter = 0;

		window.trackEvent( 'Pageview', {
			view: 'Upload'
		});
	}


	componentDidMount() {

		// TODO: PULL PROJECTS OUT OF LOCALSTORAGE AND PROMPT USER TO RE-UPLOAD VIDEO
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {

		let error = this.props.app.state.error,
			inBounds = this.state.inDropBounds;

		let upload = <div id="uploadPanel" className={ inBounds ? 'upload__drop-zone upload__drop-zone_active' : 'upload__drop-zone' }
						  onDragOver={( e ) => this.preventDefault( e )}
						  onDrop={( e ) => this.filesDropped( e )}
						  onDragEnter={( e ) => this.inBounds( e )}
						  onDragLeave={( e ) => this.outOfBounds( e )}
						  onDragEnd={( e ) => this.outOfBounds( e )}>

			<article className="upload__drop-zone__inner">
				<div>

					{/* CHECK FOR ERROR MESSAGES --------------------------------------------*/}
					{(function () {
						if ( error ) return <article>
								<h2>Uh Oh!</h2>
								<h3>{ error }</h3>
							</article>;

						else return <article className={ inBounds ? 'ani-grow' : undefined }>
								<h2>
									{ inBounds ?
										'Drop it like it\'s hot!'
									: window.localProject ?
										'Please re-upload ' + window.localProject.videoName
									: 'Drag & Drop Here!' }</h2>
							</article>;

					})()}

					<div className={ inBounds ? 'btn btn_blue btn_exit-bottom' : 'btn btn_blue' }>

						<input id="fileLoader" type="file" accept="video/*" onChange={( e ) => this.loadVideo( e )} />

						Select Video
					</div>
				</div>
			</article>
		</div>;

		return <div className="app-container">

			<header className="header">
				<div>
					<div className="logo" onClick={( e ) => this.prevStep( e )}><img src={ window.devicePixelRatio >= 2 ? logo2x : logo } /></div>
					<h3>Project: <strong>{ this.props.app.state.projectName }</strong></h3>
				</div>
			</header>

			<div className="upload">

				<div className="upload__title">
					<small>Project Name</small>
					<h1>{ this.props.app.state.projectName }</h1>
				</div>
				{ upload }
			</div>
		</div>;
	}


	// NEED THIS TO ACTUALLY PREVENT DEFAULT BEHAVIOUR. THIS IS DUE TO A BUG IN CHROME
	// =============================================================================================
	preventDefault( e ) {
		e.preventDefault();
	}


	// METHOD THAT SETS A HOVER STATE WHEN DRAGGIN IMAGES OVER DROP ZONE, MUST BE IN JS, DON'T WANT JUST ANY HOVER
	// =============================================================================================
	inBounds( e ) {
		e.preventDefault();

		this.dragCounter++;

		if ( !this.state.inDropBounds ) this.setState( prevState => ({ inDropBounds: true }) );
	}


	// METHOD THAT REMOVES A HOVER STATE WHEN DRAGGIN IMAGES OVER DROP ZONE, MUST BE IN JS, DON'T WANT JUST ANY HOVER
	// =============================================================================================
	outOfBounds( e ) {
		e.preventDefault();

		this.dragCounter--;

		// CHECK TO MAKE SURE TARGET IS NOT A CHILD OF THE DROP ZONE
		if ( this.state.inDropBounds && this.dragCounter === 0 ) this.setState( prevState => ({ inDropBounds: false }) );
	}


	// METHOD THAT HANDLES THE UPLOAD BUTTON INPUT AND DROP AREA
	// =============================================================================================
	filesDropped( e ) {

		e.preventDefault();

		// RESET DRAG COUNTER FOR CHECKING INSIDE BOUNDS WHEN DRAGGING FILE TO DROPZONE
		this.dragCounter = 0;

		// RESET CHECK FOR INSIDE DROP ZONE
		this.setState( prevState => ({ inDropBounds: false }) );

		// GET THE DATA TRANSFER OBJECT FROM THE EVENT, BUTTON USES e, DROP ZONE USES e.originalEvent
		let dt = e.dataTransfer || e.originalEvent.dataTransfer,
			data = dt || e.target,
			files = data.items || data.files;

		// MAKE SURE WE HAVE FILES
		if ( files && files.length ) {

			// USE DATA TRANSFER ITEM LIST INTERFACE TO ACCESS THE FILE(S)
			// -------------------------------------------------------------------------------------
			for ( let i = 0; i < files.length; i++ ) {

				// getAsFile IS USED BY THE DROP API, OTHERWISE BUTTON WAS CLICKED
				let file = files[ i ].name ? files[ i ] : files[ i ].getAsFile();

				this.loadVideo( file );
			}
		}
	}


	// LOADS A VIDEO FROM A LOCAL DRIVE AND PLAYS THAT FILE
	// =============================================================================================
	loadVideo( e ) {

		let $this = this,
			file;

		if ( e && e.target ) {
			e.preventDefault();

			// GET VIDEO FILE OBJECT
			file = e.target.files[ 0 ]

		} else file = e;

		// SET SOURCE FROM FILE
		let src = ( window.URL || window.webkitURL ).createObjectURL( file );

		let video = document.createElement( 'video' ),
			videoSize = String( ( file.size / 1024 / 1024 ).toFixed( 2 ) ),
			checkVideo = function ( e ) {

				let videoErrorMsg = false;

				// VIDEO'S SIZE TOO LARGE
				if ( file.size > 104857600 )
					videoErrorMsg = 'Sorry, this video is too large. We currently only accept videos smaller than 100MB.';

				// NOT A SUPPORTED VIDEO
				else if ( !(/.mp4|.avi|.mkv|x-matroska|.mov|quicktime/.test( file.type ) ) )
					videoErrorMsg = 'Sorry, ' + file.type.replace( 'video/', '' ) + ' format is not supported.';

				// SET VIDEO SOURCE
				$this.props.app.setState( prevState => ({
					view: videoErrorMsg ? 'upload' : 'editor',
					error: videoErrorMsg,
					fileType: file.type,
					videoFile: file,
					videoSource: videoErrorMsg ? false : src,
					videoFileSize: videoSize,
					videoName: file.name
				}) );

				video.removeEventListener( e.type, checkVideo );

				window.trackEvent( 'Video', {
					action: 'check-video',
					videoError: videoErrorMsg,
					videoType: file.type,
					videoName: file.name,
					videoSrc: src,
					videoSize: file.size,
					fileDropped: !( e && e.target )
				});
			};

		video.addEventListener( 'durationchange', checkVideo );

		video.src = src;
	}


	// =============================================================================================
	prevStep() {

		this.props.app.setState( prevState => ({
			view: 'home'
		}) );
	}
}

export default Upload;


// WEBPACK FOOTER //
// ./src/scenes/Upload/index.js